import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import _isEmpty from "lodash/isEmpty";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, PhoneInput, showError } from 'components/UI';
import { phonesWrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PhonesInput = function PhonesInput(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      onChange = _ref.onChange,
      className = _ref.className,
      isTouched = _ref.isTouched;
  var inputRef = useRef();
  useEffect(function () {
    var _inputRef$current;

    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.changeIsTouched(true);
  }, [isTouched]);

  var handleAdd = function handleAdd() {
    var _inputRef$current2, _inputRef$current3, _inputRef$current4, _inputRef$current5, _inputRef$current6;

    var codeValue = inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.dropdownValue;
    var numberValue = inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.inputValue;
    if (!codeValue || _isEmpty(numberValue)) return handleError('Задължително поле!');
    if (value.includes(inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.value)) return showError('Този номер вече е добавен!');
    _isFunction(onChange) && onChange([].concat(_toConsumableArray(value), [inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.value]));
    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 ? void 0 : _inputRef$current6.reset();
  };

  var handleDelete = function handleDelete(phone) {
    var newValue = value.filter(function (el) {
      return el !== phone;
    });
    _isFunction(onChange) && onChange(newValue);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      handleAdd();
    }
  };

  var handleError = function handleError(msg) {
    var _inputRef$current7;

    return inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current7 = inputRef.current) === null || _inputRef$current7 === void 0 ? void 0 : _inputRef$current7.setError({
      msg: msg
    });
  };

  return ___EmotionJSX("div", _extends({
    css: phonesWrap
  }, className && {
    className: className
  }), ___EmotionJSX("div", {
    className: "phones-input-row"
  }, ___EmotionJSX("div", {
    className: "phones-input-field"
  }, ___EmotionJSX(PhoneInput, {
    ref: inputRef,
    value: "+359-",
    label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0437\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
    validate: function validate() {
      return null;
    },
    onKeyDown: handleKeyDown
  })), ___EmotionJSX("div", {
    className: "phones-add-btn"
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: handleAdd
  }, ___EmotionJSX("i", {
    className: "las la-plus",
    style: {
      marginRight: 4
    }
  }), "\u0414\u043E\u0431\u0430\u0432\u0438"))), !_isEmpty(value) && ___EmotionJSX("div", {
    className: "phones-list"
  }, value.map(function (el) {
    return ___EmotionJSX("div", {
      className: "phone-chip",
      key: el
    }, ___EmotionJSX("span", null, el), ___EmotionJSX("span", {
      className: "phone-chip-remove",
      role: "button",
      tabIndex: "0",
      onClick: function onClick() {
        return handleDelete(el);
      }
    }, ___EmotionJSX("i", {
      className: "las la-times"
    })));
  })), _isEmpty(value) && ___EmotionJSX("div", {
    className: "phones-empty"
  }, ___EmotionJSX("i", {
    className: "las la-info-circle"
  }), ___EmotionJSX("span", null, "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440")));
};

PhonesInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.array,
  required: PropTypes.bool,
  isTouched: PropTypes.bool,
  onChange: PropTypes.func,
  validate: PropTypes.func
};
export default PhonesInput;